export default __webpack_public_path__ + "static/media/tradingImg.d71a3ec3.webp";